import { useQuery } from "react-query";
import { getPaymentReference } from "../services/finance/paymentReference";
import { PagedRequestType } from "../types/PagedResults";
import { Key_paymentreferences } from "../utils/constants";

export const useGetPaymentReferencesQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_paymentreferences, JSON.stringify(data)],
    () => getPaymentReference(data), 
    options?{...options}:{}
  );